import { RootState } from 'rootReducer';

export const selectSurveyContent = (state: RootState) => state._resources.survey.content;
export const selectFeedbackResult = (state: RootState) => state._resources.survey.feedBackResult;
